import React from 'react'
import { ExportProvider } from '../../components/molecules/ExportButton/ExportProvider'
import AnalyticsProvider from '../../components/atoms/AnalyticsProvider'
import OutboundSsoProvider from '../../components/organisms/OutboundSso/OutboundSsoProvider'
import SummitUtilityProvider from '../../providers/SummitUtilityProvider'
import ErrorBoundary from '../../components/molecules/ErrorBoundary'
import { WebsocketProvider } from '../../providers/WebsocketProvider'
import LoadingView from '../../components/pages/LoadingView'
import ErrorView from '../../components/pages/ErrorView'
import AcceptTerms from '../../components/pages/accept-terms'
import RestrictedView from '../../components/pages/RestrictedView'
import { useCheckPolicies } from '../../api/policy'
import { usePolicy } from '../../hooks/usePolicy'
import { useUserProfile } from '../shared/useAppShellSetup'
import DenaliLoader from './Assistant/common/DenaliLoader'
import AiApp from './index'

function DenaliAssistantApp () {
  const { userProfile, appConfigLoading } = useUserProfile()
  const { isLoading, error } = useCheckPolicies()
  const isAiEnabled = usePolicy('denali_ai_enabled')

  if (userProfile.error) {
    return <ErrorView error={userProfile.error} />
  }

  if (userProfile.isNonInteractive) {
    return <RestrictedView />
  }

  if (!userProfile.isValidTermsAcceptance) {
    return <AcceptTerms />
  }

  if (error) {
    return <ErrorView error='There was an error loading the application' />
  }

  if (isLoading || appConfigLoading || !isAiEnabled) {
    return (
      <LoadingView>
        <DenaliLoader />
      </LoadingView>
    )
  }

  return (
    <SummitUtilityProvider currentUser={userProfile}>
      <OutboundSsoProvider>
        <AnalyticsProvider currentUser={userProfile}>
          <ExportProvider>
            <ErrorBoundary name='Application level' refresh>
              <WebsocketProvider>
                <AiApp />
              </WebsocketProvider>
            </ErrorBoundary>
          </ExportProvider>
        </AnalyticsProvider>
      </OutboundSsoProvider>
    </SummitUtilityProvider>
  )
}

export default DenaliAssistantApp
